import { Activity } from "../apps/activity/model/activity";
import { Header } from "../apps/app/model/header";
import { TextContentBio } from "../apps/bio_components/textContentBio/model/textContentBio";
import { CookiePolicy } from "../apps/cookie_policy/model/cookie_Policy";
import { Credits } from "../apps/credits_componnents/body_credits/model/body_credits";
import { DirectionArtistic } from "../apps/direction_artistic_components/direction_artistic/model/direction_artistic_components";
import { Subcategory } from "../apps/direction_artistic_components/direction_artistic/model/subcategory";
import { Gallery } from "../apps/gallery_components/gallery_home/model/gallery_home";
import { Album } from "../apps/home_components/album/models/album";
import { AlbumDescription } from "../apps/home_components/album/models/album_desciption";
import { Follow } from "../apps/home_components/follow/model/follow";
import { Hero } from "../apps/home_components/heros/model/heros";
import { Lable } from "../apps/lable/model/lable";
import { Category } from "../apps/news_components/news_content/model/category";
import { NewsContent } from "../apps/news_components/news_content/model/news_content";
import { Portfolio } from "../apps/portoflio/models/portoflio";
import { PrivacyPolicy } from "../apps/privacy_policy/model/privacy_policy";
import { User } from "../apps/user/model/user";
import { LegalNotes } from "../legal_notes/model/legal_notes";
import http, { httpLocal } from "./http";

class ApiService {
  //Music
  async getMusic() {
    let result = await http.get("music/");
    return result.data.map((data) => new Album(data));
  }
  // Latest Musics
  async getLatestMusics() {
    let result = await http.get("latest-musics/");
    return result.data.map((data) => new Album(data));
  }
  
  async addMusic(formData) {
    let result = await http.post("music/", formData);
    return result.data;
  }
  async updateMusic(slug, formData) {
    let result = await http.patch("music/" + slug + "/", formData);
    return result.data;
  }
  async deleteMusic(slug) {
    let result = await http.delete(`music/${slug}`);
    return result;
  }
  async getAlbumsCategory(category) {
    let result = await http.get("music/");

    return result.data
      .filter((categorys) => categorys.category_data.name === category)
      .map((data) => new Album(data));
  }
  async getAlbumsCategorySinge(id) {
    let result = await http.get("music/" + id);
    return new Album(result.data);
  }

  //Album Desciption
  async getAlbumDesciption() {
    let result = await httpLocal.get("/data/album_desciption.json");
    return result.data.album_desciption.map(
      (data) => new AlbumDescription(data)
    );
  }
  //SlidersHero
  async getSlidersHero() {
    let result = await httpLocal.get("/data/slider_hero.json");
    return result.data.slider_hero.map((data) => new Hero(data));
  }
  // Follows
  async getFollows() {
    let result = await httpLocal.get("/data/follows.json");
    return result.data.follows.map((data) => new Follow(data));
  }
  //Bio
  async getContentTextBioS() {
    let result = await httpLocal.get("/data/bio.json");
    return result.data.bio.map((data) => new TextContentBio(data));
  }
  // InternalLink
  async getInternalLink() {
    let result = await httpLocal.get("data/internal_link.json");
    return result.data.internal_link.map((data) => new Header(data));
  }

  // News
  async getNews() {
    let result = await http.get("news/");
    return result.data.map((data) => new NewsContent(data));
  }

  // Latest News
  async getLatestNews() {
    let result = await http.get("latest-news/");
    return result.data.map((data) => new NewsContent(data));
  }

  async getNewsID(id) {
    let result = await http.get("news/" + id);
    return new NewsContent(result.data);
  }
  async addNews(formData) {
    let result = await http.post("news/", formData);
    return result.data;
  }
  async updateNews(slug, formData) {
    let result = await http.patch("news/" + slug + "/", formData);
    return result.data;
  }
  async deleteNews(id) {
    let result = await http.delete(`news/${id}`);
    return result;
  }
  // Upload File
  async uploadFile(file) {
    const formData = new FormData();

    formData.append("file", file);

    const filenameHeaderValue =
      "inline;filename=" + encodeURIComponent(file.name);

    const result = await http.put("/file/upload/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Content-Disposition": filenameHeaderValue,
        "Access-Control-Allow-Origin": "*",
      },
    });
    return result.data;
  }

  //User
  async getUser() {
    try {
      let result = await http.get("userinfo/");
      return result.data[0];
    } catch (e) {
      return null;
    }
  }
  async getUserID(id) {
    let result = await http.get("user/" + id);
    return new User(result.data);
  }

  // Login
  async login(formData) {
    let result = await http.post("login/", { ...formData });
    return result;
  }

  // Logout
  async logout() {
    let result = await http.post("logout/");
    return result.data;
  }

  // Category
  async getCategories() {
    let result = await http.get("category/");
    return result.data.map((data) => new Category(data));
  }
  async getCategoriesID(id) {
    let result = await http.get("category/" + id);
    return new Category(result.data);
  }
  async addCategory(formData) {
    let result = await http.post("category/", formData);
    return result.data;
  }
  async updateCategory(id, formData) {
    let result = await http.patch("category/" + id + "/", formData);
    return result.data;
  }
  async deleteCategory(id) {
    let result = await http.delete(`category/${id}`);
    return result;
  }
  async getSubcategories() {
    let result = await httpLocal.get("/data/subCategory.json");
    return result.data.subCategory.map((data) => new Subcategory(data));
  }

  // Direction Artistic
  async getDirectionArtistic() {
    let result = await httpLocal.get("data/artistic_direction.json");
    return result.data.artistic_direction.map(
      (data) => new DirectionArtistic(data)
    );
  }

  async getDirectionCategory(category) {
    let result = await httpLocal.get("data/artistic_direction.json");
    return result.data.artistic_direction
      .filter(
        (categorys) => categorys.category === category && categorys.subcategory
      )
      .map((data) => new DirectionArtistic(data));
  }

  // Portfolio
  async getPortfolio() {
    let result = await httpLocal.get("data/portfolio.json");
    return result.data.portfolio.map(
      (data) => new Portfolio(data)
    );
  }

  //Lable
  async getLable() {
    let result = await httpLocal.get("data/lable.json");
    return result.data.lable.map(
      (data) => new Lable(data)
    );
  }

  //credits
  async getCredits() {
    let result = await httpLocal.get("data/credits.json");
    return result.data.credits.map((data) => new Credits(data));
  }

  //Gallery
  async getGallery() {
    let result = await httpLocal.get("data/gallery.json");
    return result.data.gallery.map((data) => new Gallery(data));
  }

  //Activity
  async getActivity() {
    let result = await http.get("activities/");
    return result.data.map((data) => new Activity(data));
  }

  //Latest Activities
  async getLatestActivities() {
    let result = await http.get("latest-activities/");
    return result.data.map((data) => new Activity(data));
  }

  // Email
  async sendEmail(formData) {
    let result = await http.post("send-email/", formData);
    return result;
  }

  //Get Captcha Image
  async getCaptcha() {
    let result = await http.get("captcha-generator/");
    return result.data;
  }
  //Get Privacy Policy
  async getPrivacyPolicy() {
    let result = await httpLocal.get("data/privacy_policy.json");
    return result.data.privacy_policy.map((data) => new PrivacyPolicy(data));
  }
  //Get Legal Notes
  async getLegalNotes() {
    let result = await httpLocal.get("data/legal_notes.json");
    return result.data.legal_notes.map((data) => new LegalNotes(data));
  }
  //Get Cookie Policy
  async getCookiePolicy() {
    let result = await httpLocal.get("data/cookie_policy.json");
    return result.data.cookie_Policy.map((data) => new CookiePolicy(data));
  }
}
export default new ApiService();
